var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[_c('div',{staticClass:"main-wrapper"},[_c('main-header'),_c('callsidebar'),_c('div',{staticClass:"page-wrapper",staticStyle:{"min-height":"750px"}},[_c('div',{staticClass:"chat-main-row"},[_c('div',{staticClass:"chat-main-wrapper"},[_c('chatmiddle'),_c('chatend')],1)]),_c('chatmodal')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }